<template functional>
  <img
    :ref="data.ref"
    :style="[data.style, data.staticStyle]"
    :class="[data.class, data.staticClass]"
    src="~/assets/images/wreath.png"
    alt
  />
</template>

<script>
export default {
  name: 'Wreath',

  functional: true
}
</script>

<style scoped>
@keyframes wreath-spin {
  to {
    transform: rotate(360deg);
  }
}

img {
  animation: wreath-spin 20s linear infinite forwards;
  display: block;
  position: relative;
}
</style>
